import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  getWorkOrderNumbers (match, limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrder/workOrderNumbers?match=${match}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  create (workOrder) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrder`, workOrder, AUTH_HEADERS())
  },
  update (workOrder) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrder/update`, workOrder, AUTH_HEADERS())
  }
}
